import { Component, ElementRef, HostListener, input, QueryList, ViewChildren } from "@angular/core";
import { UserAccountId } from "../../interfaces/user-info.interface";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";

@Component({
    selector: "app-account-picker",
    imports: [MatIconModule, MatButtonModule],
    templateUrl: "./account-picker.component.html",
    styleUrls: ["./account-picker.component.scss"]
})
export class AccountPickerComponent {
    readonly accounts = input<UserAccountId[] | null>(null);

    isOpen = false;
    selectedAccount: UserAccountId | null = null;
    popupRef: ElementRef | undefined;
    activeAccountId: string | null = localStorage.getItem("accountid");

    @ViewChildren("accountPickerButton") buttons!: QueryList<ElementRef>;

    constructor(private elementRef: ElementRef) {
        this.popupRef = this.elementRef;
    }

    ngOnInit() {
        if (typeof window === "undefined") return;

        const accounts = this.accounts();
        if (accounts && accounts.length > 0) {
            this.selectedAccount = accounts[0];

            const accountId = localStorage.getItem("accountid");
            if (accountId) {
                const matchingAccount = accounts?.find((account) => account.parentcustomerid_account.accountid === accountId);
                if (matchingAccount) {
                    this.selectedAccount = matchingAccount;
                } else {
                    this.selectedAccount = accounts[0] || null;
                }
            }
        }
    }

    toggleDropdown(): void {
        this.isOpen = !this.isOpen;

        if (this.isOpen) {
            setTimeout(() => {
                const firstButton = this.buttons.first?.nativeElement;
                firstButton?.focus();
            }, 0);
        }
    }

    public selectAccount(account: UserAccountId) {
        this.selectedAccount = account;
        this.isOpen = false;
        if (typeof window !== "undefined") {
            localStorage.setItem("accountid", account.parentcustomerid_account.accountid);
            localStorage.setItem("contactid", account.contactid);
            location.reload();
        }
    }

    onKeydown(event: KeyboardEvent, index: number): void {
        const buttonsArray = this.buttons.toArray();

        if (event.key === "ArrowDown") {
            // Move focus to the next button
            event.preventDefault();
            const nextButton = buttonsArray[index + 1]?.nativeElement || buttonsArray[0]?.nativeElement;
            nextButton?.focus();
        } else if (event.key === "ArrowUp") {
            // Move focus to the previous button
            event.preventDefault();
            const prevButton = buttonsArray[index - 1]?.nativeElement || buttonsArray[buttonsArray.length - 1]?.nativeElement;
            prevButton?.focus();
        } else if (event.key === "Escape") {
            // Close the dropdown on Escape
            this.isOpen = false;
            const toggleButton = document.getElementById("account-picker-button");
            toggleButton?.focus();
        }
    }

    @HostListener("document:click", ["$event"])
    clickout(event: PointerEvent) {
        if (!this.popupRef?.nativeElement.contains(event.target)) {
            this.isOpen = false;
        }
    }
}
